export default "__VITE_ASSET__56a4b8ef__"